<form (ngSubmit)="onAddExpression()" [formGroup]="form">
  <table class="table va-middle table-striped" id="triggerSignalExpressions">
    <thead>
      <tr>
        <th translate>Correlation</th>
        <th translate>Expression type</th>
        <th translate>Table</th>
        <th translate>Signal@if (signalsLoading | async) {
          <span class="fa-solid fa-spinner fa-spin ml-2"></span>
        }</th>
        <th translate>Unit</th>
        <th translate>Operator</th>
        <th translate>Value</th>
        <th class="text-right" translate>Action</th>
      </tr>
    </thead>
    <tbody>
      @for (expr of triggerSignalExpressions; track expr; let index = $index) {
        <tr [attr.data-index]="index">
          <td>@if (index > 0) {
            <span [innerText]="expr.triggerCorrelation"></span>
          }</td>
          <td><span class="truncate truncate-sm" [innerText]="expr.triggerExpressionType"></span></td>
          <td><span class="truncate truncate-sm" [innerText]="expr.triggerTableName"></span></td>
          <td><span class="truncate truncate-sm" [innerText]="expr.signalLabel | translate"></span></td>
          <td><span class="truncate truncate-sm" [innerText]="expr.signalUnit"></span></td>
          <td [innerText]="getOperatorSymbol(expr.arithmeticOperator)"></td>
          <td [innerText]="expr.triggerLastValue"></td>
          <td class="text-right">
            <button (click)="onRemoveExpression(index, expr)" [disabled]="!isAdminOrHigher"
              class="btn btn-sm btn-outline-danger" title="{{ 'Delete expression' | translate}}"
              type="button">
              <span class="fa-solid fa-trash"></span>
            </button>
          </td>
        </tr>
      }
      <tr>
        <td>
          @if (triggerSignalExpressions.length>0) {
            <ng-select (change)="onTriggerExpressionTypeChange($event)" (focusout)="onFocusOut()"
              [disabled]="isAdminOrHigher" [items]="correlations"
              [ngClass]="{ 'is-invalid': formControls.correlation.errors }" formControlName="correlation"
              id="correlation">
            </ng-select>
          }
          <input [hidden]="true" [ngClass]="{ 'is-invalid': formControls.correlation.errors }" class="form-control"
            id="selectedCorrelation" type="text">
          </td>
          <td>
            <ng-select (change)="onTriggerExpressionTypeChange($event)" (focusout)="onFocusOut()"
              [disabled]="isAdminOrHigher" [items]="triggerExpressionTypes"
              [ngClass]="{ 'is-invalid': formControls.expressionType.errors }" formControlName="expressionType"
              id="expressionType">
            </ng-select>
            <input [hidden]="true" [ngClass]="{ 'is-invalid': formControls.expressionType.errors }" class="form-control"
              id="selectedExpressionType" type="text">
            </td>
            <td></td>
            <td>
              <ng-select (focusout)="onFocusOut()" [disabled]="!isAdminOrHigher"
                [items]="signals"
                [ngClass]="{ 'is-invalid':formControls.signal.errors }"
                bindLabel="signalLabel" bindValue="signalName"
                [placeholder]="'Select a gateway first...' | translate"
                style="width: 220px;"
                formControlName="signal" id="signal">
                <ng-template let-item="item" ng-label-tmp>
                  <span [innerText]="item.signalLabel | translate"></span>
                </ng-template>
                <ng-template let-item="item" ng-option-tmp>
                  <div><span class="truncate" [title]="item.signalLabel | translate" [innerText]="item.signalLabel | translate"></span></div>
                  <small class="truncate" [innerText]="item.signalName" [title]="item.signalName"></small>
                </ng-template>
              </ng-select>
              <input [hidden]="true" [ngClass]="{ 'is-invalid': formControls.signal.errors }" class="form-control"
                id="selectedSignal" type="text">
              </td>
              <td></td>
              <td>
                @if (operators.length>0) {
                  <ng-select (focusout)="onFocusOut()"
                    [disabled]="!isAdminOrHigher" [items]="operators"
                    [ngClass]="{ 'is-invalid':formControls.operator.errors }" bindLabel="value" bindValue="key"
                    formControlName="operator" id="operator">
                  </ng-select>
                }
                <input [hidden]="true" [ngClass]="{ 'is-invalid': formControls.operator.errors }" class="form-control"
                  id="selectedOperator" type="text">
                </td>
                <td>
                  @if (formControls.expressionType.value === triggerExpressionTypesEnum.CONDITION) {
                    <input (focusout)="onFocusOut()"
                      [disabled]="!isAdminOrHigher"
                      [ngClass]="{ 'is-invalid': formControls.lastValue.errors }" class="form-control"
                      formControlName="lastValue"
                      id="lastValue" name="lastValue" type="text">
                  }
                </td>
                <td class="text-right">
                  <button [disabled]="addExpressionDisabled()" class="btn btn-sm btn-primary"
                    title="{{ 'Add expression' | translate }}" type="submit">
                    <span class="fa-solid fa-plus"></span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </form>